import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './routes/index'
import store from './store'
//import './registerServiceWorker'
import md5 from 'md5'
import VueSignaturePad from 'vue-signature-pad';
import listAbrechnung from '@/components/abrechnung/list-abrechnung.vue';
import ConsoleLogger from '@/classes/Utils/ConsoleLogger';
import VueShepherd from 'vue-shepherd'
import 'shepherd.js/dist/css/shepherd.css'

Vue.use(VueShepherd)

const logger = new ConsoleLogger({
  maxEntries: 1000,
  logTypes: ['log', 'warn', 'error', 'info']
});

Vue.prototype.$logger = logger;
window.logger = logger; // Make logger globally accessible

Vue.use(VueSignaturePad);

Vue.component('list-abrechnung', listAbrechnung);
Vue.component('abrechnung-card', () => import('@/components/abrechnung/abrechnung-card.vue'));

Vue.config.productionTip = false
Vue.prototype.client = md5(process.env.VUE_APP_CLIENT_ID)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
